<template>
    <div class="home_view1">
        <img class="home_view2" src="../assets/icon2.png" alt=""/>
        <div class="home_view3">
            <div style="display: flex">欢迎光临<div v-if="shopName">【{{shopName}}】</div></div>
            <img class="home_view4" src="../assets/icon1.png" alt=""/>
            <div @click="showKeyboard = true" class="home_view5">
                {{ entry_code}}
                <view v-if="!entry_code" class="home_view11">请输入四位进店码</view>
                <view v-if="showKeyboard" class="custom-cursor"></view>
            </div>
        </div>
        <van-number-keyboard
            v-model="entry_code"
            :show="showKeyboard"
            @blur="handleHide"
            :hide-on-click-outside="false"
            :maxlength="4"
        />
        <van-overlay :show="show_error">
            <div class="home_view6">
                <div class="home_view7">
                    <div class="home_view8">{{error_text}}</div>
                    <div class="home_view9">
                        <div @click="show_error = false; showKeyboard = true" class="home_view10">
                            我知道了
                        </div>
                    </div>

                </div>
            </div>
        </van-overlay>

    </div>
</template>

<script setup>
import {ref, onMounted, watch} from 'vue'
import { useRoute } from 'vue-router'
import {closeToast, showLoadingToast, showToast} from "vant";
import {checkCode, domainUrl, proxyName} from "@/api/user";

const entry_code = ref('')
const showKeyboard = ref(true)
const params_query = ref(false)
const show_error = ref(false)
const error_text = ref('')
const shopName = ref('')
const route = useRoute()


// 生命周期 created
onMounted(() => {
    if(!route.query) {
        show_error.value = true
        error_text.value = '二维码有误，请重新生成'
        return
    }
    if(!route.query.query) {
        show_error.value = true
        error_text.value = '二维码有误，请重新生成'
        return
    }
    const query = JSON.parse(route.query.query)
    if(!query.c) {
        show_error.value = true
        error_text.value = '未发现c，请重新生成'
        return
    }
    params_query.value = query
    changeJoin()
    getProxyName()
})
watch(entry_code, (newVal) => {
    if (newVal.length === 4) {
        handleDone()
    }
});

// 方法定义
const handleDone = () => {
    if(entry_code.value.length !== 4) {
        return showToast('请输入四位进店码')
    }
    const params = {
        shopId: params_query.value.c,
        joinShopCode: entry_code.value,
    }
    showLoadingToast({
        message: '进店中...',
        forbidClick: true,
    });
    checkCode(params).then((res) => {
        closeToast()
        if(res && res.code === 200) {
            if(res.data) {
                showLoadingToast({
                    message: '进店中...',
                    forbidClick: true,
                });
                domainUrl('wcz_h5').then((res) => {
                    closeToast()
                    if(res && res.code === 200) {
                        localStorage.setItem(params_query.value.c, params_query.value.c);
                        window.location.href = res.data + '/' + window.location.hash
                    }
                })
            }else {
                closeToast()
                entry_code.value = ''
                show_error.value = true
                error_text.value = '进店码不正确，请重新输入\n如遗忘，请联系店主获取。'
            }
        }else {
            closeToast()
            show_error.value = true
            error_text.value = res.msg
        }
    })
}

const handleHide = () => {
    showKeyboard.value = false
}

const changeJoin = () => {
    const data = localStorage.getItem(params_query.value.c);
    if(data == params_query.value.c) {
        showLoadingToast({
            message: '进店中...',
            forbidClick: true,
        });
        domainUrl('wcz_h5').then((res) => {
            closeToast()
            if(res && res.code === 200) {
                localStorage.setItem(params_query.value.c, params_query.value.c);
                window.location.href = res.data + '/' + window.location.hash
            }
        })
    }
}

const getProxyName = () => {
    proxyName({proxyNo: params_query.value.b}).then((d) => {
        if(d.code === '0000') {
            shopName.value = d.result
        }
    })
}

</script>

<style scoped lang="scss">
.home_view1 {
    position: relative;
}
.home_view2 {
    width: 100vw;
    height: 592px;
    object-fit: cover;
    position: absolute;
    top: -1px;
    left: 0;
}
.home_view3 {
    width: 100vw;
    font-weight: 600;
    font-size: 40px;
    color: #333333;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    background-color: #FFF8F9;
    position: absolute;
    top: 472px;
    border-radius: 20px;
    padding-top: 30px;
}
.home_view4 {
    width: 412px;
    height: 92px;
    margin: 20px 0 0 0;
}
.home_view5 {
    width: 629px;
    height: 109px;
    background: #FFFFFF;
    box-shadow: 5px 0 10px 0 #F4EDEE;
    border-radius: 10px 10px 10px 10px;
    margin: 50px 0 0 0;
    font-weight: 400;
    font-size: 36px;
    color: #333333;
    display: flex;
    align-items: center;
    justify-content: center;
}

.custom-cursor {
    width: 2px;
    height: 34px;
    background-color: #000000;
    animation: blink 1s infinite;
}

/* 光标闪烁动画 */
@keyframes blink {
    0%, 100% {
        opacity: 1;
    }
    50% {
        opacity: 0;
    }
}
.home_view6 {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 100%;
}
.home_view7 {
    width: 519px;
    height: 300px;
    background: #FFFFFF;
    border-radius: 10px;
}
.home_view8 {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 180px;
    border-bottom: 1px solid #E2E2E2;
    font-weight: 400;
    font-size: 30px;
    color: #333333;
    padding: 0 50px;
    text-align: center;
    white-space: pre;
}
.home_view9 {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 120px;
}
.home_view10 {
    width: 300px;
    height: 80px;
    background: #F32A4C;
    border-radius: 20px;
    font-weight: 400;
    font-size: 30px;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
}
.home_view11 {
    font-weight: 400;
    font-size: 36px;
    color: #B3B3B3;
}
</style>
<style>
body {
    background-color: #FFF8F9;
}
</style>
